"use client";
import React from "react";
import SearchFill from "atd-icons/dist/SearchFill";
import clsx from "clsx";
import useSearchStore from "@/stores/search-store";

const SearchModal = () => {
  const showSearch = useSearchStore((state) => state.showSearch);
  const hideSearch = useSearchStore((state) => state.hideSearch);
  const searchModalVisible = useSearchStore(
    (state) => state.searchModalVisible,
  );
  return (
    <>
      <li
        className={
          "border-r border-r-[rgba(255,255,255,0.3)] h-[32px] hidden xl:block"
        }
      ></li>
      <li
        className={clsx({
          "relative text-slate-800 pointer-events-auto main-nav-item text-button": true,
          "py-3 w-full xl:w-auto": true,
          "items-center justify-center": true,
        })}
      >
        <button
          className={"text-white"}
          onClick={showSearch}
          aria-label="Search"
        >
          <SearchFill
            size={20}
            className={"inline-block mt-[-4px] me-3 xl:me-0"}
          />
          <span className={"xl:hidden"}>Search</span>
        </button>
      </li>
    </>
  );
};

export default SearchModal;
